
<template>
  <div id="app">

<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script type="text/javascript" rel="stylesheet">



window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
export default {
  name: 'app'
}
</script>



// WEBPACK FOOTER //
// src/App.vue